// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { getLocator, getAspectRatio } from '@tcp/core/src/utils';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import {
  renderDifferentImageOnMobile,
  getDisableVideosOnAppleValue,
} from '../utils/LinkedImage.utils';
import { StyledImageSection, StyledDamImage } from '../styles/LinkedImage.style';

const LinkedImage = (props) => {
  const { linkedImage, isHomePage, disableVideosForAppleDevice, moduleAnalyticsTag } = props;
  const { link = {}, image = {}, video = {}, imageMobile = {}, videoMobile = {} } = linkedImage;

  const { extraConfig } = React.useContext(LabelsContext);
  const { isDamImageV2Enabled, disableVideosForAppleDeviceValue } = extraConfig || {};

  const showDifferentImageOnMobile = !!imageMobile;
  const showVideoOnMobile = !!videoMobile;
  const aspectRatioObj = getAspectRatio(image, video, imageMobile, videoMobile);

  return (
    <StyledImageSection className="tabbed-image-section">
      {renderDifferentImageOnMobile(showDifferentImageOnMobile, showVideoOnMobile) ? (
        <StyledDamImage
          lazyLoad
          isModule
          preloadImage
          isEnableMute
          isOptimizedVideo
          link={link}
          imgData={imageMobile}
          isHomePage={isHomePage}
          className="moduletabbed_image"
          aspectRatioObj={aspectRatioObj}
          isDamImageV2Enabled={isDamImageV2Enabled}
          dataLocator={`${getLocator('moduletabbed_image')}`}
          disableVideosForAppleDevice={getDisableVideosOnAppleValue(
            disableVideosForAppleDevice,
            disableVideosForAppleDeviceValue
          )}
          moduleAnalyticsTag={moduleAnalyticsTag}
        />
      ) : (
        <StyledDamImage
          imgData={image}
          videoData={video}
          showVideoOnMobile={showVideoOnMobile}
          videoDataMobile={videoMobile}
          className="moduletabbed_image"
          dataLocator={`${getLocator('moduletabbed_image')}`}
          isOptimizedVideo
          isHomePage
          isDamImageV2Enabled={isDamImageV2Enabled}
          link={link}
          lazyLoad
          isModule
          disableVideosForAppleDevice={getDisableVideosOnAppleValue(
            disableVideosForAppleDevice,
            disableVideosForAppleDeviceValue
          )}
          aspectRatioObj={aspectRatioObj}
          preloadImage
          isEnableMute
          moduleAnalyticsTag={moduleAnalyticsTag}
        />
      )}
    </StyledImageSection>
  );
};

LinkedImage.propTypes = {
  isHomePage: PropTypes.bool.isRequired,
  linkedImage: PropTypes.shape({
    link: PropTypes.shape({}),
    image: PropTypes.shape({}),
    video: PropTypes.shape({}),
    imageMobile: PropTypes.shape({}),
    videoMobile: PropTypes.shape({}),
  }).isRequired,
  disableVideosForAppleDevice: PropTypes.bool.isRequired,
};

LinkedImage.defaultProps = {};

LinkedImage.displayName = 'LinkedImage';

export default LinkedImage;
export { LinkedImage as LinkedImageVanilla };
